import { take, put, call, select } from "redux-saga/effects"
import restRequest from "src/engine/modules/rest/api/request"
import env from "src/env"
import redirectToLoginPage from "src/engine/modules/session/helpers/redirectToLoginPage"
import { REFRESH_TOKEN } from "../actions/types"
import {
  lockRequests,
  unlockRequests,
  logout,
  setToken,
  setTokens,
} from "../actions/creators"
import { refreshToken as selectRefreshToken } from "../selectors"

const {
  REACT_APP_REFRESH_TOKEN_URL,
  REACT_APP_CLIENT_ID,
} = env

export default function* refreshTokenSaga() {
  while (true) {
    yield take(REFRESH_TOKEN)

    /* Now, we should immediatly lock requests */
    yield put(lockRequests())
    /* Delete current token */
    yield put(setToken(undefined))

    /* Select curret refresh_token */
    const refreshToken = yield select(selectRefreshToken)

    if (!refreshToken) {
      /* Looks like an error, redirect to login */
      return put(logout())
    }

    /* Perform request to server to repair token */
    try {
      const { data } = yield call(
        restRequest,
        REACT_APP_REFRESH_TOKEN_URL,
        {},
        {
          headers: {},
          method: `post`,
          body: {
            refresh_token: refreshToken,
          },
        },
      )

      const nextToken = data.access_token

      if (!nextToken) {
        /* Looks like an error, redirect to login */
        return put(logout())
      }

      /* Update token */
      yield put(
        setTokens(
          data.token_type,
          data.access_token,
          data.refresh_token,
          data.expires_in,
        ),
      )

      /* Unlock requests */
      yield put(unlockRequests())
    } catch (e) {
      redirectToLoginPage()
      /* Looks like an error, redirect to login */
      return put(logout())
    }
  }
}
